var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelegramHover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#0098EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.39368 11.7355C8.88334 10.1831 11.2103 9.15973 12.3746 8.66527C15.699 7.2535 16.3897 7.00826 16.84 7.00008C16.939 6.99838 17.1604 7.02344 17.3038 7.14226C17.4249 7.2426 17.4583 7.37813 17.4742 7.47325C17.4901 7.56838 17.51 7.78508 17.4942 7.9544C17.3141 9.88701 16.5346 14.5769 16.138 16.7415C15.9702 17.6574 15.6398 17.9645 15.3199 17.9945C14.6248 18.0599 14.0969 17.5255 13.4236 17.0749C12.3701 16.3697 11.7749 15.9308 10.7522 15.2427C9.57034 14.4475 10.3365 14.0104 11.01 13.2962C11.1863 13.1092 14.2492 10.2648 14.3084 10.0067C14.3159 9.97446 14.3227 9.85417 14.2527 9.79065C14.1828 9.72713 14.0794 9.74885 14.0049 9.76612C13.8992 9.79061 12.2162 10.9264 8.95566 13.1736C8.47792 13.5086 8.04521 13.6718 7.6575 13.6632C7.23009 13.6538 6.40793 13.4165 5.79673 13.2136C5.04708 12.9648 4.45127 12.8333 4.50315 12.4107C4.53017 12.1906 4.82702 11.9656 5.39368 11.7355Z",
    fill: "#F7F9FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramHover);
export default __webpack_public_path__ + "static/media/telegram-hover.77cc792e2278a378c6de33152f8950e6.svg";
export { ForwardRef as ReactComponent };